
function AtmLocalService($rootScope, LocalStorageService, $state) {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$local = LocalStorageService;
    this.KEY_STATES = 'states';
    this.$local.setItem(this.KEY_STATES, JSON.stringify({}));

    // save the state with the date time everytime the state change
    this.$rootScope.$on('$stateChangeSuccess', () => {
        if ($state.current && $state.current.name) {
            this.saveState(this.$state.current.name);
        }
    });
}

AtmLocalService.prototype.saveState = function (stateName) {
    const states = JSON.parse(this.$local[this.KEY_STATES]);
    states[stateName] = Date.now();
    this.$local.setItem(this.KEY_STATES, JSON.stringify(states));
};

AtmLocalService.prototype.getState = function (stateName) {
    const states = JSON.parse(this.$local[this.KEY_STATES]);
    return states[stateName];
};

module.exports = AtmLocalService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/atm-local-service.js
 **/